import React from "react";
import Button from "@Components/Button";
import ButtonLink from "@Components/ButtonLink";
import DoubleSlider from "@Components/DoubleSlider";
import FormCalendar from "@Components/Form/Calendar";
import Dropdown from "@Components/Form/Dropdown";
import DropdownNew from "@Components/Form/Dropdown/New";
import FormGroup from "@Components/Form/Group";
import FormHeader from "@Components/Form/Header";
import FormInput from "@Components/Form/Input";
import LargeFormInput from "@Components/Form/LargeInput";
import LargeFormInputNew from "@Components/Form/LargeInput/New";
import LargeToggle from "@Components/Form/LargeToggle";
import MultiTextAdd from "@Components/Form/MultiTextAdd";
import MultiTextAddNew from "@Components/Form/MultiTextAdd/New";
import RadioGroup from "@Components/Form/RadioGroup";
import RadioGroupNew from "@Components/Form/RadioGroup/New";
import RepeatGroup from "@Components/Form/RepeatGroup";
import RepeatGroupNew from "@Components/Form/RepeatGroup/New";
import TwoWayToggleSmall from "@Components/Form/TwoWayToggleSmall";
import TwoWayToggleSmallNew from "@Components/Form/TwoWayToggleSmall/New";
import Loading from "@Components/Icons/Loading";
import buttonStyles from "@Components/Sass/buttons.module.scss";
import SingleSlider from "@Components/SingleSlider";
import styles from "./index.module.scss";
export var InputType;
(function (InputType) {
    InputType[InputType["Text"] = 0] = "Text";
    InputType[InputType["LargeText"] = 1] = "LargeText";
    InputType[InputType["Number"] = 2] = "Number";
    InputType[InputType["Password"] = 3] = "Password";
    InputType[InputType["Currency"] = 4] = "Currency";
    InputType[InputType["FakeCurrency"] = 5] = "FakeCurrency";
    InputType[InputType["Percentage"] = 6] = "Percentage";
    InputType[InputType["Lines"] = 7] = "Lines";
    InputType[InputType["GB"] = 8] = "GB";
    InputType[InputType["SmallToggle"] = 9] = "SmallToggle";
    InputType[InputType["LargeToggle"] = 10] = "LargeToggle";
    InputType[InputType["LargeToggleNew"] = 11] = "LargeToggleNew";
    InputType[InputType["DropdownOptions"] = 12] = "DropdownOptions";
    InputType[InputType["DropdownOptionsNew"] = 13] = "DropdownOptionsNew";
    InputType[InputType["DropdownEnum"] = 14] = "DropdownEnum";
    InputType[InputType["DropdownEnumNew"] = 15] = "DropdownEnumNew";
    InputType[InputType["Slider"] = 16] = "Slider";
    InputType[InputType["DoubleSlider"] = 17] = "DoubleSlider";
    InputType[InputType["Email"] = 18] = "Email";
    InputType[InputType["MultiAddText"] = 19] = "MultiAddText";
    InputType[InputType["Calendar"] = 20] = "Calendar";
    InputType[InputType["Group"] = 21] = "Group";
    InputType[InputType["RepeatGroup"] = 22] = "RepeatGroup";
    InputType[InputType["RadioGroup"] = 23] = "RadioGroup";
    InputType[InputType["PlusMinus"] = 24] = "PlusMinus";
    InputType[InputType["TextNew"] = 25] = "TextNew";
    InputType[InputType["PasswordNew"] = 26] = "PasswordNew";
    InputType[InputType["EmailNew"] = 27] = "EmailNew";
    InputType[InputType["LinesNew"] = 28] = "LinesNew";
    InputType[InputType["CurrencyNew"] = 29] = "CurrencyNew";
    InputType[InputType["GBNew"] = 30] = "GBNew";
    InputType[InputType["SmallToggleNew"] = 31] = "SmallToggleNew";
    InputType[InputType["LargeTextNew"] = 32] = "LargeTextNew";
    InputType[InputType["RadioGroupNew"] = 33] = "RadioGroupNew";
    InputType[InputType["MultiAddTextNew"] = 34] = "MultiAddTextNew";
    InputType[InputType["RepeatGroupNew"] = 35] = "RepeatGroupNew";
    InputType[InputType["NumberNew"] = 36] = "NumberNew";
})(InputType || (InputType = {}));
export default class Form extends React.Component {
    static defaultProps = {
        className: "",
        autocomplete: true,
        cancel: "",
        buttonText: "SUBMIT",
        disabled: false,
        input: [],
        data: {},
        buttons: true,
        noSave: false,
        errors: {},
        submit: () => {
            console.log("Submit!");
        },
        rightButton: false,
    };
    constructor(props) {
        super(props);
        const formGroups = this.props.input.reduce((fg, input) => {
            const { type, name } = input;
            if (type !== InputType.RepeatGroup) {
                return fg;
            }
            fg[name] = this.props.data[name] ? this.props.data[name].length : 1;
            return fg;
        }, {});
        this.state = {
            loading: false,
            componentIsMounted: true,
            formGroups,
            customValidationMessages: {},
        };
    }
    componentWillUnmount() {
        this.setState({
            componentIsMounted: false,
        });
    }
    async submit(events) {
        events.preventDefault();
        this.setState({ loading: true });
        this.runCustomValidation();
        const callback = await this.props.submit();
        if (this.state.componentIsMounted) {
            this.setState({ loading: false });
            return typeof callback === "function" ? callback() : callback;
        }
    }
    runCustomValidation = () => {
        const customValidationMessages = {};
        for (const { customValidation, name } of this.props.input) {
            if (customValidation === undefined)
                continue;
            const currentValue = this.props.data[name];
            const message = customValidation(currentValue);
            if (message !== "") {
                customValidationMessages[name] = message;
            }
        }
        this.setState({
            customValidationMessages,
        });
    };
    clearErrorMessage = (name) => {
        if (this.state.customValidationMessages[name] !== undefined) {
            const customValidationMessages = {
                ...this.state.customValidationMessages,
            };
            delete customValidationMessages[name];
            this.setState({ customValidationMessages });
        }
    };
    reportChange = (field, value) => {
        const data = { ...this.props.data };
        if (this.props.change) {
            data[field] = value;
            this.props.change(data);
        }
        if (this.props.inputChange) {
            const input = this.props.input.find(({ name }) => name === field);
            if (input) {
                this.props.inputChange({ ...input, value });
            }
        }
    };
    change = (field, value) => {
        this.reportChange(field, value);
    };
    changeDropdown = ({ field, option }) => {
        this.reportChange(field, option.value);
    };
    changeRepeatedDropdown = (index, group, { field, option }) => {
        return this.changeRepeatedComponent(index, group, field, option.value);
    };
    changeRepeatedComponent = (index, group = "test", field, value) => {
        const { [group]: g = [] } = this.props.data;
        const object = g[index] || {};
        object[field] = value;
        g[index] = object;
        this.reportChange(group, g);
    };
    repeatGroupChange = (name) => (data) => {
        this.reportChange(name, data);
    };
    changeMultiDropdown = ({ field, option, }) => {
        const value = option.map(({ value }) => value);
        this.reportChange(field, value);
    };
    createComponent = ({ name, group, type, options, placeholder, multi, characters, range, headers, validText, separators, ticks, max, min, disabled, groupInputs, index, limit, relative, toggleOptions, repeatText, repeatButtonRound, small, noDecimal, green, roundEdges, blue, showPassword, filterOptions, addButton, long, reducedWidth, left, time, defaultObj, newDesign, }) => {
        const getField = (data, name, group, index) => {
            try {
                if (group && index !== undefined) {
                    return data[group][index][name];
                }
                return data[name];
            }
            catch {
                return;
            }
        };
        const value = getField(this.props.data, name, group, index);
        const error = getField(this.props.errors, name, group, index);
        const change = index === undefined
            ? this.change
            : this.changeRepeatedComponent.bind(this, index, group);
        const dropdownChange = index === undefined
            ? multi === true
                ? this.changeMultiDropdown
                : this.changeDropdown
            : this.changeRepeatedDropdown.bind(this, index, group);
        switch (type) {
            case InputType.Number:
                return (React.createElement(FormInput, { error: error, value: value, placeholder: placeholder, name: name, type: "number", valueChanged: change, disabled: disabled, blue: blue, setErrors: this.props.setErrors, left: left, customErrorMessage: this.state.customValidationMessages[name], clearErrorMessage: this.clearErrorMessage }));
            case InputType.Password:
                return (React.createElement(FormInput, { error: error, value: value, placeholder: placeholder, name: name, type: "password", valueChanged: change, disabled: disabled, showPassword: showPassword, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name], clearErrorMessage: this.clearErrorMessage }));
            case InputType.Lines:
                return (React.createElement(FormInput, { error: error, value: value, placeholder: placeholder, name: name, type: "lines", valueChanged: change, disabled: disabled, noDecimal: noDecimal, blue: blue, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name], clearErrorMessage: this.clearErrorMessage }));
            case InputType.GB:
                return (React.createElement(FormInput, { error: error, value: value, placeholder: placeholder, name: name, type: "gb", valueChanged: change, disabled: disabled, noDecimal: noDecimal, blue: blue, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name], clearErrorMessage: this.clearErrorMessage }));
            case InputType.GBNew:
                return (React.createElement(FormInput, { error: error, value: value, placeholder: placeholder, name: name, type: "gbNew", valueChanged: change, disabled: disabled, noDecimal: noDecimal, blue: blue, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name], clearErrorMessage: this.clearErrorMessage }));
            case InputType.Currency:
                return (React.createElement(FormInput, { error: error, value: value, name: name, type: "currency", valueChanged: change, disabled: disabled, noDecimal: noDecimal, placeholder: placeholder, blue: blue, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name], clearErrorMessage: this.clearErrorMessage }));
            case InputType.CurrencyNew:
                return (React.createElement(FormInput, { error: error, value: value, name: name, type: "currencyNew", valueChanged: change, disabled: disabled, noDecimal: noDecimal, placeholder: placeholder, blue: blue, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name], clearErrorMessage: this.clearErrorMessage }));
            case InputType.FakeCurrency:
                return (React.createElement(FormInput, { error: error, value: value, name: name, type: "fakeCurrency", valueChanged: change, disabled: disabled, noDecimal: noDecimal, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name], clearErrorMessage: this.clearErrorMessage }));
            case InputType.Percentage:
                return (React.createElement(FormInput, { error: error, value: value, name: name, type: "percentage", valueChanged: change, disabled: disabled, noDecimal: noDecimal, blue: blue, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name], clearErrorMessage: this.clearErrorMessage }));
            case InputType.Text:
                return (React.createElement(FormInput, { error: error, value: value, placeholder: placeholder, name: name, maxlength: limit, type: "text", valueChanged: change, disabled: disabled, blue: blue, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name], clearErrorMessage: this.clearErrorMessage }));
            case InputType.PlusMinus:
                return (React.createElement(FormInput, { error: error, value: value, name: name, type: "currency", plusMinus: true, valueChanged: change, disabled: disabled, noDecimal: noDecimal, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name], clearErrorMessage: this.clearErrorMessage }));
            case InputType.Calendar:
                return (React.createElement(FormCalendar, { error: error, value: value, name: name, valueChanged: change, max: max, min: min, disabled: disabled, time: time }));
            case InputType.LargeText:
                return (React.createElement(LargeFormInput, { error: error, value: value, name: name, type: "text", valueChanged: change, characterLimit: characters, disabled: disabled }));
            case InputType.LargeTextNew:
                return (React.createElement(LargeFormInputNew, { error: error, value: value, name: name, type: "text", valueChanged: change, characterLimit: characters, disabled: disabled, placeholder: placeholder }));
            case InputType.Email:
                return (React.createElement(FormInput, { error: error, value: value, placeholder: placeholder, name: name, type: "email", valueChanged: change, disabled: disabled, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name], clearErrorMessage: this.clearErrorMessage }));
            case InputType.LargeToggle:
                return (React.createElement(LargeToggle, { optionSelected: change, options: toggleOptions, selected: value, name: name, error: error, disabled: disabled, small: small, green: green, setErrors: this.props.setErrors, long: long, reducedWidth: reducedWidth, newDesign: newDesign }));
            case InputType.LargeToggleNew:
                return (React.createElement(LargeToggle, { optionSelected: change, options: toggleOptions, selected: value, name: name, error: error, disabled: disabled, small: small, green: green, setErrors: this.props.setErrors, long: long, reducedWidth: reducedWidth, newDesign: true }));
            case InputType.RadioGroup:
                return (React.createElement(RadioGroup, { value: value, valueChange: change, name: name, options: options, error: error }));
            case InputType.RadioGroupNew:
                return (React.createElement(RadioGroupNew, { value: value, valueChange: change, name: name, options: options, error: error }));
            case InputType.DropdownEnum:
                return (React.createElement(Dropdown, { enum: options, error: error, onChange: dropdownChange, placeholder: placeholder, value: value, isMulti: multi, name: name, disabled: disabled, relative: relative, setErrors: this.props.setErrors, filterOptions: filterOptions }));
            case InputType.DropdownEnumNew:
                return (React.createElement(DropdownNew, { enum: options, error: error, onChange: dropdownChange, placeholder: placeholder, value: value, isMulti: multi, name: name, disabled: disabled, relative: relative, setErrors: this.props.setErrors, filterOptions: filterOptions }));
            case InputType.DropdownOptions:
                return (React.createElement(Dropdown, { options: options, error: error, onChange: dropdownChange, placeholder: placeholder, value: value, isMulti: multi, name: name, disabled: disabled, relative: relative, setErrors: this.props.setErrors, filterOptions: filterOptions }));
            case InputType.DropdownOptionsNew:
                return (React.createElement(Dropdown, { options: options, error: error, onChange: dropdownChange, placeholder: placeholder, value: value, isMulti: multi, name: name, disabled: disabled, relative: relative, setErrors: this.props.setErrors, filterOptions: filterOptions, newDesign: true }));
            case InputType.SmallToggle:
                return (React.createElement(TwoWayToggleSmall, { toggle: change, value: value, name: name, disabled: disabled, green: green }));
            case InputType.SmallToggleNew:
                return (React.createElement(TwoWayToggleSmallNew, { toggle: change, value: value, name: name, disabled: disabled, green: green }));
            case InputType.MultiAddText:
                return (React.createElement(MultiTextAdd, { name: name, error: error, values: value, onChange: change, format: validText, separators: separators, placeHolder: placeholder, disabled: disabled, limit: limit }));
            case InputType.MultiAddTextNew:
                return (React.createElement(MultiTextAddNew, { name: name, error: error, values: value, onChange: change, format: validText, separators: separators, placeHolder: placeholder, disabled: disabled, limit: limit }));
            case InputType.Slider:
                return (React.createElement(SingleSlider, { value: value, update: change, name: name, range: range, ticks: ticks, headers: headers(value), disabled: disabled, error: error }));
            case InputType.DoubleSlider:
                return (React.createElement(DoubleSlider, { value: value, update: change, name: name, range: range, disabled: disabled, error: error }));
            case InputType.RepeatGroup:
                return (React.createElement(RepeatGroup, { data: value, error: error, change: this.repeatGroupChange(name), inputs: groupInputs, repeatText: repeatText, repeatButtonRound: repeatButtonRound, roundEdges: roundEdges, addButton: addButton, defaultObj: defaultObj }));
            case InputType.RepeatGroupNew:
                return (React.createElement(RepeatGroupNew, { data: value, error: error, change: this.repeatGroupChange(name), inputs: groupInputs, repeatText: repeatText, repeatButtonRound: repeatButtonRound, roundEdges: roundEdges, addButton: addButton, defaultObj: defaultObj }));
            case InputType.TextNew:
                return (React.createElement(FormInput, { error: error, value: value, placeholder: placeholder, name: name, maxlength: limit, type: "textNew", valueChanged: change, disabled: disabled, blue: blue, small: small, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name] ||
                        error?.[0], clearErrorMessage: this.clearErrorMessage }));
            case InputType.PasswordNew:
                return (React.createElement(FormInput, { error: error, value: value, placeholder: placeholder, name: name, type: "passwordNew", valueChanged: change, disabled: disabled, showPassword: showPassword, small: small, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name] ||
                        error?.[0], clearErrorMessage: this.clearErrorMessage }));
            case InputType.EmailNew:
                return (React.createElement(FormInput, { error: error, value: value, placeholder: placeholder, name: name, type: "emailNew", valueChanged: change, disabled: disabled, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name] ||
                        error?.[0], clearErrorMessage: this.clearErrorMessage }));
            case InputType.LinesNew:
                return (React.createElement(FormInput, { error: error, value: value, placeholder: placeholder, name: name, type: "linesNew", valueChanged: change, disabled: disabled, noDecimal: true, blue: blue, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name], clearErrorMessage: this.clearErrorMessage }));
            case InputType.NumberNew:
                return (React.createElement(FormInput, { error: error, value: value, placeholder: placeholder, name: name, type: "numberNew", valueChanged: change, disabled: disabled, noDecimal: noDecimal, blue: blue, setErrors: this.props.setErrors, customErrorMessage: this.state.customValidationMessages[name] ||
                        error?.[0], clearErrorMessage: this.clearErrorMessage }));
        }
    };
    render() {
        const horizontal = this.props.horizontal ? styles.horizontal : "";
        const notes = this.props.input.some(({ notes }) => notes !== undefined && notes !== "");
        const topNotes = this.props.input.some(({ topNotes }) => topNotes !== undefined && topNotes !== "");
        const inputs = this.props.input.map(({ extraComponent, ...input }, index) => (React.createElement(FormGroup, { label: input.label, key: index, hidden: input.hidden, notes: input.notes || (notes ? " " : undefined), topNotes: input.topNotes || (topNotes ? " " : undefined), badge: input.badge, width: input.badgeWidth, labelLeft: this.props.labelLeft, topRight: this.props.topRight, className: `${styles.formGroup} ${styles.topRight} ${horizontal} ${input.className}`, inputClassName: input.inputClassName, noPadding: input.noPadding, horizontal: this.props.horizontal, longerInput: this.props.longerInput || input.longerInput, narrowLabel: this.props.narrowLabel, labelTooltip: input.labelTooltip },
            this.createComponent(input),
            extraComponent)));
        const { loading } = this.state;
        return (React.createElement("div", { className: `${loading ? styles.loading : ""} ${this.props.className} ${styles.wrapper}` },
            React.createElement("form", { onSubmit: this.submit.bind(this), autoComplete: this.props.autocomplete ? `on` : `off`, className: `predict-form ${horizontal}`, noValidate: this.props.input.some(({ customValidation }) => customValidation !== undefined) },
                this.props.header !== undefined && (React.createElement(FormHeader, null, this.props.header)),
                this.props.topSlot,
                inputs,
                this.props.buttons && (React.createElement(FormGroup, { className: buttonStyles.splitGroups },
                    this.props.cancel == "" &&
                        this.props.noSave === false &&
                        this.props.rightButton === false && (React.createElement("div", { className: buttonStyles.buttonGroupLeft },
                        React.createElement(Button, { disabled: this.props.disabled, type: "submit" }, this.props.buttonText))),
                    this.props.cancel == "" &&
                        this.props.noSave === false &&
                        this.props.rightButton === true && (React.createElement("div", { className: buttonStyles.buttonGroupRight },
                        React.createElement(Button, { disabled: this.props.disabled, type: "submit" }, this.props.buttonText))),
                    this.props.cancel !== "" && (React.createElement("div", { className: buttonStyles.splitGroups },
                        React.createElement("div", { className: buttonStyles.buttonGroupLeft },
                            React.createElement(Button, { disabled: this.props.disabled, type: "submit", className: buttonStyles.buttons }, this.props.buttonText)),
                        React.createElement("div", { className: buttonStyles.buttonGroupRight },
                            React.createElement(ButtonLink, { dark: true, to: this.props.cancel, className: buttonStyles.buttons }, "CANCEL")))))),
                this.props.bottomSlot,
                this.props.children,
                loading && (React.createElement(Loading, { size: "5rem", className: styles.spinner })))));
    }
}
